import React, { useEffect } from "react";
import useTranslation from "next-translate/useTranslation";
import { TheCycleverseTheme } from "src/theme";
import { makeStyles } from "@material-ui/core/styles";

import BikeCompareButtonTeaser from "./BikeCompareButtonTeaser";
import SpecificationTable from "src/components/Content/Specification/SpecificationTable";
import MainLayout from "../Layout/MainLayout";
import SeoHead from "../Seo/SeoHead";
import { BikeCompareStorage } from "./BikeCompareStorage";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  content: {
    textAlign: "center",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      paddingLeft: theme.globalMarginDesktop,
      paddingRight: theme.globalMarginDesktop,
    },
    [`${theme.breakpoints.down("sm")} and (orientation: landscape)`]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  table: {
    maxWidth: "100%",
    textAlign: "left",
    display: "inline-block",
  },
  teaser: {
    textAlign: "right",
    [theme.breakpoints.down("xs")]: {
      marginLeft: theme.globalMarginMobile,
      marginRight: theme.globalMarginMobile,
    },
  },
}));

const Page = (props) => {
  const { flavor, seoIds } = props;
  const { t } = useTranslation("common");
  const classes = useStyles();
  const products = props.products || [];

  const bikes = Object.keys(products)
    .map((key) => {
      const data = products[key];
      const items = data?.items;
      const item = items && items.length > 0 ? items[0] : null;
      if (item && seoIds.indexOf(item.seoId) < 0) {
        return null;
      }
      return item;
    })
    .filter((e) => e != null);

  useEffect(() => {
    if (bikes.length != seoIds.length) {
      const missingBikes = seoIds.filter((seoId) => bikes.filter((bike) => seoId == bike.seoId).length <= 0);
      missingBikes.map((missingBike) => {
        BikeCompareStorage.removeBike(flavor, missingBike);
      });
    }
  }, [bikes, seoIds, flavor]);

  if (!products) {
    return null;
  }

  const nameList = bikes.map((bike) => `${bike.brand} ${bike.title}`).join(" ✅ ");

  return (
    <MainLayout>
      <SeoHead
        title={t(`bikeComparisonMetaTitle_${flavor}`, { nameList })}
        description={t(`bikeComparisonMetaDescription_${flavor}`, { length: bikes.length, nameList })}
        keywords={t(`bikeComparisonMetaKeywords_${flavor}`, {
          bikes: bikes.map((bike) => `${bike.brand} ${bike.title}`).join(","),
        })}
        ogImage={`https://rlin39iwxc.execute-api.eu-west-1.amazonaws.com/prod/?i=${bikes
          .map((bike) => bike.id)
          .join(",")}`}
        ogDescription={t(`bikeComparisonMetaDescription_${flavor}`, { length: bikes.length, nameList })}
      >
        <meta name="robots" content="noindex" />
      </SeoHead>

      <div
        className={classes.content}
        data-test={`page-${flavor == "biobike" ? "fahrrad" : "ebike"}-vergleich-${seoIds.join("_vs_")}`}
      >
        <div className={classes.teaser}>
          <BikeCompareButtonTeaser flavor={flavor} />
        </div>
        <SpecificationTable products={bikes} flavor={flavor} className={classes.table} />
      </div>
    </MainLayout>
  );
};

export default Page;
